/**
 * @file 当前登录用户状态
 * @description 登录后拉取 `/system/user/getInfo`，缓存昵称 / 剩余点数等顶栏所需信息。
 *
 * @whenToUse 后台壳层挂载时调用 `fetchUser`；顶栏 / 个人信息弹窗读取用户字段。
 * @whenNotToUse 登录流程本身（用 `src/api/auth.ts` 的 loginApi）。
 */

import { create } from 'zustand'
import { getUserInfoApi, type UserInfoUser } from '@/api/auth.ts'

type UserState = {
  /** 当前登录用户；未拉取成功前为 null */
  user: UserInfoUser | null
  /** 是否正在拉取 */
  loading: boolean
  /** 拉取当前用户信息（已有数据或拉取中时跳过） */
  fetchUser: () => Promise<void>
  /** 退出登录时清空，下次登录重新拉取 */
  clearUser: () => void
}

export const useUserStore = create<UserState>((set, get) => ({
  user: null,
  loading: false,
  clearUser: () => set({ user: null }),
  async fetchUser() {
    if (get().user || get().loading) return
    set({ loading: true })
    try {
      const { user } = await getUserInfoApi()
      set({ user })
    } finally {
      set({ loading: false })
    }
  },
}))
